export default __webpack_public_path__ + "static/media/bannerbackground.44182c97.jpg";